import React from "react";

import { Route, RouteComponentProps } from "react-router-dom";

import { useUserContext } from "contexts/UserContext";

import { ConsumerMonitoring } from "./ConsumerMonitoring";
import { EstimatedGeneration } from "./estimatedGeneration";
import { ProsumerMonitoring } from "./ProsumerMonitoring";

export const MonitoringRouter = ({ match: { path } }: RouteComponentProps) => {
  const { currentSpace } = useUserContext();

  return (
    <>
      <Route
        exact
        path={`${path}/`}
        component={
          currentSpace?.isProsumer ? ProsumerMonitoring : ConsumerMonitoring
        }
      />
      <Route
        path={`${path}/estimated-generation`}
        component={EstimatedGeneration}
      />
    </>
  );
};
